import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-incident-management-sichtbarkeit-admin2';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerIncidentManagementSichtbarkeitAdmin2Effects {

    BenutzerIncidentManagementSichtbarkeitAdmin2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2),
        mergeMap((x: ac.PostBenutzerIncidentManagementSichtbarkeitAdmin2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerIncidentManagementSichtbarkeitAdmin2(x.benutzerSichtbarkeitRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerIncidentManagementSichtbarkeitAdmin2ErfolgreichAction(result, x.benutzerSichtbarkeitRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerIncidentManagementSichtbarkeitAdmin2FehlerAction(error, x.benutzerSichtbarkeitRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
